"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LabelWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  height: ", ";\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize;
}, function (props) {
  return props.value ? 'space-between' : 'flex-end';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.height;
});

var _default = LabelWrapper;
exports["default"] = _default;